/*******************************************************************************
REVEALS AN ELEMENT THAT WAS HIDDEN
*******************************************************************************/

import setMinGridWidth from '../css-grid/set-min-grid-width';

export default function revealElement(e) {
    const $trigger = $(e.currentTarget);

    // Grab the element selector. Exit out if none exists.
    const elementSelector = $trigger.data('show');
    if (!elementSelector) { return; }

    // Options
    const revealMode = $trigger.data('mode') || 'fade';
    const hideClasses = $trigger.data('hideClasses') || 'hide';
    const elementsToHide = $trigger.data('hide') || '';
    const selfDestruct = ($trigger.data('selfDestruct') || '').toLowerCase() !== 'no';
    const group = $trigger.data('group') || '';
    const selectedClasses = $trigger.data('selected-classes') || '';

    // Elements
    const $elements = $(elementSelector);

    // Perform actions based on the settings
    if (selfDestruct) { $trigger.remove(); }
    if (revealMode === 'show') { $elements.removeClass(hideClasses); }
    if (revealMode === 'fade') { $elements.flexFadeIn(hideClasses); }
    if (elementsToHide) { $(elementsToHide).addClass(hideClasses); }

    // Handle changes to the selected trigger/trigger group (if set)
    if (group && selectedClasses) {
        $(group).removeClass(selectedClasses);
        $trigger.addClass(selectedClasses);
    }

    if ($elements.find('.filter-tab').length) {
        setMinGridWidth({ containers: '.filter-tabs', items: '.filter-tab', padding: '20' });
    }
}
